
<modal
  size="full"
  title="Price Check"
  :open="open"
  @close="closeModal"
>
  <div class="grid">
    <section>
      <p>Get the estimated value for any card by selecting an index and entering the price paid on a previous date.</p><br />

      <form>
        <div class="step">
          <section class="step-header">
            <h5>Select an index</h5>
          </section>

          <div>
            <p>We will use the index to forecast your card's current value based on the index value today.</p>

            <index-search
              ref="indexSearch"
              @selectPlayer="setPlayer"
              @selectIndex="setIndex"
            />

            <div v-if="index" class="index-list-container">
              <index-list-item :index="index" />
            </div>
          </div>
        </div>

        <div class="step">
          <section class="step-header">
            <h5>Enter the price paid</h5>
          </section>

          <div>
            <currency-input
              v-model="price"
              label="Past Sold Price"
              @keyup.native.enter="submit"
            />
          </div>
        </div>

        <div class="step">
          <section class="step-header">
            <h5>Enter the date purchased</h5>
          </section>

          <div>
            <p>If you can't remember the exact date just get as close as possible.</p>

            <date-input
              v-model="date"
              label="Past Sold Date"
              @keyup.native.enter="submit"
            />
          </div>
        </div>
      </form>
    </section>

    <section>
      <div v-if="output" class="output">
        <value-display
          estimated
          size="large"
          :confidence="output.confidence"
          :value="$filters.currency(output.value, { full: true })"
        />

        <div class="description">
          {{ output.description }}
        </div>
      </div>
    </section>
  </div>

  <template #footer>
    <align justify="space-between">
      <btn :disabled="!output" kind="secondary" @click="clear">
        Start Over
      </btn>

      <btn
        kind="ebay"
        :loading="checking"
        :disabled="isDisabled"
        loading-text="Checking"
        @click="submit"
      >
        Submit
      </btn>
    </align>
  </template>
</modal>
